import React from 'react';
import styles from './Onboarding.module.css';
import { Link } from 'react-router-dom';
import { brandImages } from '../../theme/brandAssets';

const Topbar = () => {

  return (
    <div className={`${styles['frow']} `} style={{padding:"0 120px 10px", boxShadow: "rgb(0 0 0 / 20%) 0px 8px 13px -3px"}}>
        <div>
          <a href='https://kynzo.io/'>
          <img className="brand-logo-img" style={{maxHeight:40, width:'auto'}} src={brandImages.wordmarkOnLight} alt='Kynzo'></img>
          <span style={{marginLeft:"10px"}}>Kynzo</span>
          </a>
        </div>
        <div className={`${styles['row']} `}>
           
            <div className={`${styles['button']} `}><Link to='/Onboarding/CreateAccount' style={{color:"white"}}>Join Kynzo for Free</Link></div>
        </div>
    </div>
  );
};
export default Topbar;
